<template>
  <v-card class="pa-4 group-logo" outlined>
    <div class="wrap-btn mb-2">
      <v-btn icon color="primary" @click="generateRandomLogo">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <div class="mt-4">
      <canvas ref="canvas" style="border: 1px solid #ccc; display: none; width: 100%;"></canvas>
      <div class="wrap-preview">
        <div>
          <img v-show="outputImage" :src="outputImage" alt="Logo result" />
        </div>
      </div>
    </div>

    <div>
      <v-text-field :value="text" @input="onInput" placeholder="Logo name" />
      <v-checkbox v-model="useIcon" @change="changeUseIcon" inset label="show icon" class="ml-2" />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'GenerateLogo',
  props: {
    name: {
      type: String,
      default: 'My Logo',
    },
  },
  data() {
    return {
      demo1: true,
      text: this.name,
      font: 'Danfo',
      color: '#3498db',
      useIcon: true,
      iconCode: '󰌪',
      position: 'left',
      fonts: [
        'Poppins',
        'Bungee',
        'Borel',
        'Diplomata',
        'Abril Fatface',
        'Yesteryear',
        'Rubik Puddles',
        'Danfo',
        'Kablammo',
        'Londrina Outline',
        'Nosifer',
        'Rubik Beastly',
        'Rubik Bubbles',
        'Rubik Puddles',
      ],
      icons: [
        { label: 'mdi-heart-pulse', value: '󰗶' },
        { label: 'mdi-heart-multiple-outline', value: '󰩗' },
        { label: 'mdi-folder-heart', value: '󱃪' },
        { label: 'mdi-axis', value: '󰵈' },
        { label: 'mdi-corn', value: '󰞸' },
        { label: 'mdi-bee', value: '󰾡' },
        { label: 'mdi-bee-flower', value: '󰾢' },
        { label: 'mdi-flower-tulip', value: '󰧱' },
        { label: 'mdi-leaf', value: '󰌪' },
        { label: 'mdi-sprout', value: '󰹦' },
        { label: 'mdi-weather-cloudy', value: '󰖐' },
        { label: 'mdi-weather-fog', value: '󰖑' },
        { label: 'mdi-water', value: '󰖌' },
        { label: 'mdi-pizza', value: '󰐉' },
        { label: 'mdi-noodles', value: '󱅾' },
        { label: 'mdi-moon-full', value: '󰽢' },
        { label: 'mdi-snowflake', value: '󰜗' },
        { label: 'mdi-vector-arrange-above', value: '󰕔' },
        { label: 'mdi-ferry', value: '󰈓' },
        { label: 'mdi-sail-boat', value: '󰻈' },
        { label: 'mdi-ship-wheel', value: '󰠳' },
        { label: 'mdi-anchor', value: '󰀱' },
        { label: 'mdi-motorbike', value: '󰍼' },
        { label: 'mdi-airballoon', value: '󰀜' },
        { label: 'mdi-rocket-launch', value: '󱓞' },
        { label: 'mdi-rocket', value: '󰑣' },
        { label: 'mdi-bag-personal', value: '󰸐' },
        { label: 'mdi-bag-suitcase', value: '󱖋' },
        { label: 'mdi-tooltip-outline', value: '󰔦' },
        { label: 'mdi-tooltip', value: '󰔣' },
        { label: 'mdi-format-paint', value: '󰉼' },
        { label: 'mdi-badminton', value: '󰡑' },
        { label: 'mdi-trophy-outline', value: '󰔺' },
        { label: 'mdi-basket', value: '󰁶' },
        { label: 'mdi-star', value: '󰓎' },
        { label: 'mdi-hexagon-multiple', value: '󰛡' },
        { label: 'mdi-rhombus-split', value: '󰨑' },
        { label: 'mdi-bat', value: '󰭟' },
        { label: 'mdi-bird', value: '󱗆' },
        { label: 'mdi-cat', value: '󰄛' },
        { label: 'mdi-cow', value: '󰆚' },
        { label: 'mdi-tortoise', value: '󰴻' },
        { label: 'mdi-unicorn-variant', value: '󱗃' },
        { label: 'mdi-rodent', value: '󱌧' },
        { label: 'mdi-owl', value: '󰏒' },
        { label: 'mdi-linux', value: '󰌽' },
        { label: 'mdi-rabbit', value: '󰤇' },
        { label: 'mdi-music-note-eighth', value: '󰎈' },
      ],
      positions: ['left', 'right', 'center'],
      colors: [
        '#3498db',
        '#2980b9',
        '#1e90ff',
        '#0d6efd',
        '#3b82f6',
        '#e74c3c',
        '#c0392b',
        '#ef4444',
        '#dc2626',
        '#ff4d4f',
        '#2ecc71',
        '#27ae60',
        '#22c55e',
        '#16a34a',
        '#10b981',
        '#9b59b6',
        '#8e44ad',
        '#9333ea',
        '#7e22ce',
        '#6d28d9',
        '#f39c12',
        '#e67e22',
        '#f97316',
        '#f59e0b',
        '#facc15',
        '#34495e',
        '#2c3e50',
        '#6b7280',
        '#4b5563',
        '#111827',
      ],
      outputImage: '',
    };
  },
  async mounted() {
    await this.loadFont('Material Design Icons');
    this.generateRandomLogo();
  },

  methods: {
    onInput(value) {
      this.$emit('update:name', value);
    },

    changeUseIcon(value) {
      this.useIcon = value;
      this.renderLogo();
    },

    randomItem(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    },

    async generateRandomLogo() {
      this.font = this.randomItem(this.fonts);
      this.color = this.randomItem(this.colors);
      this.iconCode = this.randomItem(this.icons).value;
      this.position = this.randomItem(this.positions);
      await this.loadFont(this.font);
      this.renderLogo();
    },

    async loadFont(fontName) {
      try {
        await document.fonts.load(`40px "${fontName}"`);
        console.log(`Font ${fontName} loaded successfully`);
      } catch (error) {
        console.warn(`Failed to load font ${fontName}:`, error);
      }
    },

    renderLogo() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext('2d');

      const { text, font, color, position, iconCode, useIcon } = this;
      const fontSize = 40;
      const iconSize = 50;
      const padding = 0;

      let textMetrics, textWidth, textHeight;
      let firstPart = text,
        secondPart = '';
      let firstPartWidth = 0,
        secondPartWidth = 0;

      ctx.font = `${fontSize}px "${font}"`;
      textMetrics = ctx.measureText(text);
      textWidth = textMetrics.width;
      textHeight = fontSize;

      let forceSplit = false;
      if (useIcon && position === 'center') {
        const spaceIndex = text.trim().indexOf(' ');
        if (spaceIndex !== -1) {
          firstPart = text.substring(0, spaceIndex).trim();
          secondPart = text.substring(spaceIndex + 1).trim();
          firstPartWidth = firstPart ? ctx.measureText(firstPart).width : 0;
          secondPartWidth = secondPart ? ctx.measureText(secondPart).width : 0;
          forceSplit = true;
        } else {
          // If no space, split text roughly in half
          const mid = Math.floor(text.length / 2);
          firstPart = text.substring(0, mid).trim();
          secondPart = text.substring(mid).trim();
          firstPartWidth = firstPart ? ctx.measureText(firstPart).width : 0;
          secondPartWidth = secondPart ? ctx.measureText(secondPart).width : 0;
          forceSplit = true;
        }
      } else if (useIcon) {
        const spaceIndex = text.trim().indexOf(' ');
        if (spaceIndex !== -1) {
          firstPart = text.substring(0, spaceIndex).trim();
          secondPart = text.substring(spaceIndex + 1).trim();
          firstPartWidth = firstPart ? ctx.measureText(firstPart).width : 0;
          secondPartWidth = secondPart ? ctx.measureText(secondPart).width : 0;
          forceSplit = true;
        }
      }

      let width, height;
      if (useIcon && forceSplit && position === 'center') {
        width = firstPartWidth + iconSize + secondPartWidth + padding * 4;
        height = Math.max(iconSize, textHeight) + padding * 2;
      } else if (useIcon && ['left', 'right'].includes(position)) {
        width = iconSize + textWidth + padding * 3;
        height = Math.max(iconSize, textHeight) + padding * 2;
      } else if (useIcon) {
        width = Math.max(iconSize, textWidth) + padding * 2;
        height = iconSize + textHeight + padding * 3;
      } else {
        width = textWidth + padding * 2;
        height = textHeight + padding * 2;
      }

      // Handle DPI
      const ratio = window.devicePixelRatio || 1;
      const scaleFactor = 5;
      const scale = ratio * scaleFactor;
      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.scale(scale, scale);

      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = color;

      ctx.font = `${fontSize}px "${font}"`;
      let textY = height / 2 + textHeight / 3;

      if (useIcon && forceSplit && position === 'center') {
        // Icon in the center with text split on both sides
        ctx.fillText(firstPart, padding, textY);
        ctx.font = `${iconSize}px "Material Design Icons"`;
        const iconX = padding + firstPartWidth + padding;
        const iconY = height / 2 + iconSize / 3;
        ctx.fillText(iconCode, iconX, iconY);

        ctx.font = `${fontSize}px "${font}"`;
        ctx.fillText(secondPart, iconX + iconSize + padding, textY);
      } else if (useIcon && forceSplit) {
        // Icon between text parts for other positions
        ctx.fillText(firstPart, padding, textY);
        ctx.font = `${iconSize}px "Material Design Icons"`;
        const iconX = padding + firstPartWidth + padding;
        const iconY = height / 2 + iconSize / 3;
        ctx.fillText(iconCode, iconX, iconY);

        ctx.font = `${fontSize}px "${font}"`;
        ctx.fillText(secondPart, iconX + iconSize + padding, textY);
      } else if (useIcon) {
        // Original logic for left/right positions
        ctx.font = `${iconSize}px "Material Design Icons"`;
        let iconX = 0,
          iconY = 0,
          textX = padding;

        switch (position) {
          case 'left':
            iconX = padding;
            iconY = height / 2 + iconSize / 3;
            textX = iconX + iconSize + padding;
            break;
          case 'right':
            textX = padding;
            iconX = textX + textWidth + padding;
            iconY = height / 2 + iconSize / 3;
            break;
          default:
            textX = padding;
            iconX = (width - iconSize) / 2;
            iconY = padding + iconSize;
            break;
        }

        ctx.fillText(iconCode, iconX, iconY);

        ctx.font = `${fontSize}px "${font}"`;
        ctx.fillText(text, textX, textY);
      } else {
        // Only text
        ctx.fillText(text, padding, textY);
      }

      this.outputImage = canvas.toDataURL('image/png');
      this.$emit('update:outputImage', this.outputImage);
    },
    async handleUploadLogo() {
      if (!this.outputImage) return;
      try {
        const blob = await fetch(this.outputImage).then(res => res.blob());
        const file = new File([blob], `logo-${Date.now()}.png`, { type: 'image/png' });
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    name: {
      handler() {
        this.text = this.name;
        this.renderLogo();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Borel&family=Bungee&family=Danfo&family=Diplomata&family=Fredoka:wght@300..700&family=Kablammo&family=Londrina+Outline&family=Nosifer&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Rubik+Beastly&family=Rubik+Bubbles&family=Rubik+Puddles&family=Yesteryear&display=swap');
.wrap-btn {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.group-logo {
  .wrap-btn {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.wrap-preview {
  min-height: 150px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .wrap-btn {
    position: absolute;
    top: 0;
    right: 0;
  }
  img {
    max-width: 100%;
    height: auto;
    max-height: 130px;
  }
}
</style>
